import { SectionHead } from "./Home";
import { Truck, ShieldCheck, Package, Clock } from "lucide-react";

export default function Spedizioni() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12 md:py-20">
      <SectionHead
        eyebrow="Spedizioni"
        title="Come spediamo i tuoi ordini"
        subtitle="Due opzioni sicure e trasparenti per farti arrivare le tue carte a casa."
        icon={<Truck size={16} />}
      />

      <div className="mt-10 grid md:grid-cols-2 gap-5">
        {/* Vinted */}
        <div className="border border-[#C9A227]/20 rounded-sm p-6 bg-[#0b0b0d]">
          <div className="eyebrow mb-3 flex items-center gap-2"><Package size={14} /> Opzione 1</div>
          <h3 className="font-display text-2xl font-extrabold text-white">Vinted</h3>
          <p className="text-sm text-[#D1D5DB] mt-3 leading-relaxed">
            Consegna tramite la piattaforma Vinted, ideale per singole carte e ordini di piccolo valore.
            Tracking incluso, tempi standard del corriere Vinted (2-4 giorni lavorativi).
          </p>
          <ul className="mt-4 space-y-2 text-sm text-[#D1D5DB]">
            <li className="flex items-center gap-2"><span className="text-[#C9A227]">▸</span> Tracking incluso</li>
            <li className="flex items-center gap-2"><span className="text-[#C9A227]">▸</span> Ideale per singole e piccoli ordini</li>
            <li className="flex items-center gap-2"><span className="text-[#C9A227]">▸</span> Costi ridotti</li>
          </ul>
        </div>

        {/* BRT */}
        <div className="border border-[#C9A227] rounded-sm p-6 bg-[#0b0b0d] relative overflow-hidden">
          <div className="absolute -top-8 -right-8 w-32 h-32 rounded-full bg-[#C9A227]/8" />
          <div className="relative">
            <div className="eyebrow mb-3 flex items-center gap-2"><ShieldCheck size={14} /> Opzione 2 — Consigliata per ordini importanti</div>
            <h3 className="font-display text-2xl font-extrabold text-white">Corriere privato BRT</h3>
            <p className="text-sm text-[#D1D5DB] mt-3 leading-relaxed">
              Corriere privato BRT con tracking completo e consegna in 24-48h in tutta Italia.
              Possibilità di attivare la <span className="text-[#C9A227] font-semibold">spedizione assicurata fino a € 2.500</span> al costo aggiuntivo di soli <span className="text-[#C9A227] font-semibold">€ 20</span>.
            </p>
            <ul className="mt-4 space-y-2 text-sm text-[#D1D5DB]">
              <li className="flex items-center gap-2"><span className="text-[#C9A227]">▸</span> Consegna 24-48h in Italia</li>
              <li className="flex items-center gap-2"><span className="text-[#C9A227]">▸</span> Assicurazione opzionale fino a € 2.500 → +€ 20</li>
              <li className="flex items-center gap-2"><span className="text-[#C9A227]">▸</span> Ideale per box, case e graded</li>
              <li className="flex items-center gap-2"><span className="text-[#C9A227]">▸</span> Imballo con bolla d'aria + toploader</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Delivery times */}
      <div className="mt-10 border border-[#C9A227]/20 rounded-sm p-6 bg-[#0b0b0d]">
        <div className="eyebrow mb-3 flex items-center gap-2"><Clock size={14} /> Tempi di consegna</div>
        <div className="grid md:grid-cols-2 gap-4">
          <TimeBlock
            flag="🇯🇵"
            title="Prodotti Giapponesi (One Piece + Pokémon)"
            time="15-20 giorni lavorativi"
            note="Dal momento dell'ordine (per prodotti già disponibili). Per i preorder JP fa fede la data di uscita indicata sulla scheda prodotto. Ordiniamo direttamente da fornitori giapponesi selezionati."
          />
          <TimeBlock
            flag="🇬🇧🇮🇹"
            title="One Piece EN + Pokémon Italiano"
            time="5-7 giorni lavorativi"
            note="Per i prodotti già disponibili. Per i preorder EN in allocazione fa fede la data di uscita ufficiale indicata sulla scheda prodotto."
          />
        </div>
      </div>
    </div>
  );
}

const TimeBlock = ({ flag, title, time, note }) => (
  <div className="border-l-2 border-[#C9A227] pl-4 py-2">
    <div className="text-xs font-mono-ps uppercase tracking-widest text-[#C9A227] flex items-center gap-2">
      <span>{flag}</span>
      <span>{title}</span>
    </div>
    <div className="font-display text-2xl font-extrabold text-white mt-2">{time}</div>
    <p className="text-xs text-[#9CA3AF] mt-2 leading-relaxed">{note}</p>
  </div>
);
